import React, {useState} from 'react';
import Slider from './Slider';
import _ from 'lodash';
import RadarChart from './RadarChart';
import Polar from './Polar';
import Button from '@material-ui/core/Button';
import pl from './translations/pl_PL.json';
import eng from './translations/en_EN.json';

export default function CustomizedSlider(props) {

    const t = (translation_key) => {
        const lang = props.lang;
        const translations =  {
            "pl_PL": pl,
            "en_EN": eng
        }
        return translations[lang][translation_key];
    }

    const wordsObject = [
        [{
            id: 1,
            name: t("active"),
            value: 50,
        },
        {
            id: 2,
            name: t("vital"),
            value: 50,
        }],
        [{
            id: 3,
            name: t("detailed"),
            value: 50,
        },
        {
            id: 4,
            name: t("sentimental"),
            value: 50,
        }],
        [{
            id: 5,
            name: t("enthusiastic"),
            value: 50,
        },
        {
            id: 6,
            name: t("appreciating"),
            value: 50,
        }],
        [{
            id: 7,
            name: t("logical"),
            value: 50,
        },
        {
            id: 8,
            name: t("dramatic"),
            value: 50,
        }],
        [{
            id: 9,
            name: t("compatible"),
            value: 50,
        },
        {
            id: 10,
            name: t("hardWorking"),
            value: 50,
        }],
        [{
            id: 11,
            name: t("precise"),
            value: 50,
        },
        {
            id: 12,
            name: t("decided"),
            value: 50,
        }],
        [{
            id: 13,
            name: t("frank"),
            value: 50,
        },
        {
            id: 14,
            name: t("technical"),
            value: 50,
        }],
        [{
            id: 15,
            name: t("daredevil"),
            value: 50,
        },
        {
            id: 16,
            name: t("calm"),
            value: 50,
        }],
        [{
            id: 17,
            name: t("meticulous"),
            value: 50,
        },
        {
            id: 18,
            name: t("peppy"),
            value: 50,
        }],
        [{
            id: 19,
            name: t("strong"),
            value: 50,
        },
        {
            id: 20,
            name: t("concise"),
            value: 50,
        }],
        [{
            id: 21,
            name: t("popular"),
            value: 50,
        },
        {
            id: 22,
            name: t("impressive"),
            value: 50,
        }],
        [{
            id: 23,
            name: t("consistent"),
            value: 50,
        },
        {
            id: 24,
            name: t("cooperating"),
            value: 50,
        }],
        [{
            id: 25,
            name: t("kind"),
            value: 50,
        },
        {
            id: 26,
            name: t("provocative"),
            value: 50,
        }],
        [{
            id: 27,
            name: t("patient"),
            value: 50,
        },
        {
            id: 28,
            name: t("spontaneous"),
            value: 50,
        }],
        [{
            id: 29,
            name: t("talkative"),
            value: 50,
        },
        {
            id: 30,
            name: t("competitive"),
            value: 50,
        }],
        [{
            id: 31,
            name: t("supporting"),
            value: 50,
        },
        {
            id: 32,
            name: t("fullOfLife"),
            value: 50,
        }],
        [{
            id: 33,
            name: t("optimistic"),
            value: 50,
        },
        {
            id: 34,
            name: t("systematic"),
            value: 50,
        }],
        [{
            id: 35,
            name: t("selfDependent"),
            value: 50,
        },
        {
            id: 36,
            name: t("generous"),
            value: 50,
        }]
    ];
    
    const reset = [
        [{
            id: 1,
            name: t("active"),
            value: 50,
        },
        {
            id: 2,
            name: t("vital"),
            value: 50,
        }],
        [{
            id: 3,
            name: t("detailed"),
            value: 50,
        },
        {
            id: 4,
            name: t("sentimental"),
            value: 50,
        }],
        [{
            id: 5,
            name: t("enthusiastic"),
            value: 50,
        },
        {
            id: 6,
            name: t("appreciating"),
            value: 50,
        }],
        [{
            id: 7,
            name: t("logical"),
            value: 50,
        },
        {
            id: 8,
            name: t("dramatic"),
            value: 50,
        }],
        [{
            id: 9,
            name: t("compatible"),
            value: 50,
        },
        {
            id: 10,
            name: t("hardWorking"),
            value: 50,
        }],
        [{
            id: 11,
            name: t("precise"),
            value: 50,
        },
        {
            id: 12,
            name: t("decided"),
            value: 50,
        }],
        [{
            id: 13,
            name: t("frank"),
            value: 50,
        },
        {
            id: 14,
            name: t("technical"),
            value: 50,
        }],
        [{
            id: 15,
            name: t("daredevil"),
            value: 50,
        },
        {
            id: 16,
            name: t("calm"),
            value: 50,
        }],
        [{
            id: 17,
            name: t("meticulous"),
            value: 50,
        },
        {
            id: 18,
            name: t("peppy"),
            value: 50,
        }],
        [{
            id: 19,
            name: t("strong"),
            value: 50,
        },
        {
            id: 20,
            name: t("concise"),
            value: 50,
        }],
        [{
            id: 21,
            name: t("popular"),
            value: 50,
        },
        {
            id: 22,
            name: t("impressive"),
            value: 50,
        }],
        [{
            id: 23,
            name: t("consistent"),
            value: 50,
        },
        {
            id: 24,
            name: t("cooperating"),
            value: 50,
        }],
        [{
            id: 25,
            name: t("kind"),
            value: 50,
        },
        {
            id: 26,
            name: t("provocative"),
            value: 50,
        }],
        [{
            id: 27,
            name: t("patient"),
            value: 50,
        },
        {
            id: 28,
            name: t("spontaneous"),
            value: 50,
        }],
        [{
            id: 29,
            name: t("talkative"),
            value: 50,
        },
        {
            id: 30,
            name: t("competitive"),
            value: 50,
        }],
        [{
            id: 31,
            name: t("supporting"),
            value: 50,
        },
        {
            id: 32,
            name: t("fullOfLife"),
            value: 50,
        }],
        [{
            id: 33,
            name: t("optimistic"),
            value: 50,
        },
        {
            id: 34,
            name: t("systematic"),
            value: 50,
        }],
        [{
            id: 35,
            name: t("selfDependent"),
            value: 50,
        },
        {
            id: 36,
            name: t("generous"),
            value: 50,
        }]
    ];
    

    const [words, setValue] = useState(wordsObject);
    const [page, setPage] = useState(true);
    
    const [DISCred, setRed] = useState(0);
    const [DISCgreen, setGreen] = useState(0);
    const [DISCblue, setBlue] = useState(0);
    const [DISCyellow, setYellow] = useState(0);

    const yellow = (words) => {
        const w = _.flattenDeep(words)
        const yellow = w[1].value + w[20].value + w[4].value + w[7].value + w[28].value + w[27].value + w[31].value + w[32].value + w[17].value
        return yellow;
    }
    const green = (words) => {
        const w = _.flattenDeep(words)
        const green = w[3].value + w[5].value + w[23].value + w[24].value + w[8].value + w[26].value + w[30].value + w[15].value + w[35].value
        return green;
    }

    const red = (words) => {
        const w = _.flattenDeep(words)
        const red = w[0].value + w[18].value + w[21].value + w[25].value + w[12].value + w[29].value + w[34].value + w[11].value + w[14].value
        return red;
    }

    const blue = (words) => {
        const w = _.flattenDeep(words)
        const blue  = w[19].value + w[2].value + w[22].value + w[6].value + w[9].value + w[10].value + w[13].value + w[33].value + w[16].value
        return blue;
    }

    const onSend = (words) => {
        setYellow(yellow(words));
        setGreen(green(words));
        setBlue(blue(words));
        setRed(red(words));
        setPage(false);
    }

    const onReset = () => {
        setValue(JSON.parse(JSON.stringify(reset)));
        setPage(true);
    }

    const Test = () => words.map((word, id) => <Slider left={word[0]} right={word[1]} setValue={setValue} id={id} words={words}/>)
    const CheckYourColor = () => <center><Button onClick={()=>onSend(words)} variant="contained"  color="secondary">{t("checkYourColorButton")}</Button></center>;
    const Again = () => <center><Button onClick={()=>onReset()} variant="contained"  color="secondary">{t("again")}</Button></center>;
 
    return (
    <div>
        
        {page ? <><Test /><CheckYourColor /></>:
        <><Again /><Polar red={DISCred} green={DISCgreen} blue={DISCblue} yellow={DISCyellow}/></>}
        {/* <RadarChart red={DISCred} green={DISCgreen} blue={DISCblue} yellow={DISCyellow}/> */}
        
    </div>
  );
}
